import { createContentPropTypes } from '../../../../helpers/content';

const overLimitErrorContent = {
	header: 'Exceeds online limit',
	description: 'We’re unable to book an exchange rate online as this payment is over the online rate booking limit.',
	enquiryDescription:
		'Please give us a call on {contactNumber} to book an exchange rate. Once you’ve spoken to our team, select the checkbox to confirm an exchange rate has been booked then enter the reference and rate you’re provided with.',
};
const chainBuildOrDifferentCurrencyErrorContent = {
	description:
		'You are unable to make this payment online, please check your details and try again. If this issue persists, please contact us on 0800 121 7365.',
};
const ratesFailedErrorContent = {
	header: 'Sorry, something’s gone wrong',
	description:
		'It looks like something’s gone wrong in the background while obtaining an exchange rate and calculating this payment. Please go back and try submitting this payment again later.',
};
const exceedsPreBookedLimitErrorContent = {
	header: 'Exceeds online limit',
	description:
		'The maximum amount you can transfer online is £10M, please give us a call on 0800 121 4209 to discuss alternatives.',
};
const missedCurrencyCutOffContent = {
	header: 'Missed currency cut-off time',
	description:
		'We’re unable to book an exchange rate online right now as you’ve missed your chosen currency’s cut-off time.',
	enquiryDescription:
		'Please give us a call on {contactNumber} if you want to book an exchange rate and submit your payment for processing on the next available business day.',
	checkBoxDescription:
		'Once you’ve spoken to our team, select the checkbox to confirm an exchange rate has been booked then enter the reference and rate you’re provided with',
};

export default {
	ratesFailedErrorContent,
	overLimitErrorContent,
	chainBuildOrDifferentCurrencyErrorContent,
	exceedsPreBookedLimitErrorContent,
	missedCurrencyCutOffContent,
};

export const contentPropTypes = createContentPropTypes(ratesFailedErrorContent);
